<template>
  <div class="itsm-page">
    <header class="page-header">
      <img src="../../assets/operations/itsm-header.png" class="header-line" />
      <div class="header-inner">
        <h1>IT服务管理系统(ITSM)</h1>
        <p class="header-desc">
          构建标准化、流程化、自动化的IT服务管理体系，提升IT服务质量，降低运营成本<br>
          让您可以轻松管理、诊断和解决网络性能问题及故障
        </p>
        <div class="service-tags">
          <div class="tag-item">
            <img src="../../assets/operations/itsm1.png" />
            <span>服务请求</span>
          </div>
          <div class="tag-item">
            <img src="../../assets/operations/itsm2.png" />
            <span>智能分派</span>
          </div>
          <div class="tag-item">
            <img src="../../assets/operations/itsm3.png" />
            <span>快速处理</span>
          </div>
          <div class="tag-item">
            <img src="../../assets/operations/itsm4.png" />
            <span>服务交付</span>
          </div>
        </div>
      </div>
    </header>

    <section class="itsm-overview">
      <h2>ITSM IT服务管理系统概览</h2>
      <div class="overview-cards">
        <div class="overview-card">
          <img src="../../assets/operations/itsm5.png" />
          支持ITIL4.0+实践框架及全生命周期
        </div>
        <div class="overview-card">
          <img src="../../assets/operations/itsm6.png" />
          智能服务台，提升服务效率，优化用户体验
        </div>
        <div class="overview-card">
          <img src="../../assets/operations/itsm7.png" />
          快速灵活的流程引擎，开箱即用或自定义配置
        </div>
        <div class="overview-card">
          <img src="../../assets/operations/itsm8.png" />
          统一的配置管理数据库(CMBD),可视化IT资产
        </div>
        <div class="overview-card">
          <img src="../../assets/operations/itsm9.png" />
          自动化工作流引擎，大幅度提升运维效率
        </div>
        <div class="overview-card">
          <img src="../../assets/operations/itsm10.png" />
          白皮化定制能力，满足企业个性化需求
        </div>
      </div>
    </section>

    <section class="features-intro">
      <h2>功能介绍</h2>
      <div class="features-cards">
        <div class="feature-card">
          <h3>智能服务台与工单管理</h3>
          <p>统一服务入口，支持多渠道接入。智能工单分派，自动化流程处理，实时跟踪服务状态。</p>
        </div>
        <div class="feature-card">
          <h3>事件与问题管理</h3>
          <p>快速响应IT事件，根本原因分析，建立问题知识库，预防重复事件发生。</p>
        </div>
        <div class="feature-card">
          <h3>变更与发布管理</h3>
          <p>标准化变更流程，降低变更风险。自动化发布管理，实现服务连续性。</p>
        </div>
        <div class="feature-card">
          <h3>配置管理数据库(CMDB)</h3>
          <p>构建IT资产全景视图，自动发现和更新配置项，可视化展示服务依赖关系。</p>
        </div>
        <div class="feature-card">
          <h3>知识库管理</h3>
          <p>集中管理IT知识资产，智能搜索和推荐，支持协作编辑，知识共享。</p>
        </div>
        <div class="feature-card">
          <h3>IT资产管理</h3>
          <p>全生命周期资产管理，从采购到报废，实时追踪资产使用情况，优化资产配置。</p>
        </div>
        <div class="feature-card">
          <h3>自动化与编排</h3>
          <p>可视化流程世纪器，零代码创建自动化流程，集成RPA能力，实现端到端自动化。</p>
        </div>
        <div class="feature-card">
          <h3>报表与分析</h3>
          <p>实时仪表展示关键指标，多维度数据分析，自定义报表模版，满足不同管理需求。</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ItsmPage'
}
</script>

<style lang="scss">
.itsm-page {
  width: 100%;
  overflow-x: hidden;
  color: #333;
  background-color: #fff;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  .page-header {
    height: 560px;
    background: url("../../assets/operations/itsm-header-bg.jpg") no-repeat center center / cover;
    text-align: center;
    position: relative;

    .header-line {
      height: 400px;
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .header-inner {
    max-width: 1180px;
    margin: 0 auto;
    padding-top: 60px;
  }

  .page-header h1 {
    font-size: 38px;
    color: #1f2d3d;
    margin-bottom: 16px;
  }

  .header-desc {
    font-size: 16px;
    color: #475669;
    line-height: 1.6;
    margin-bottom: 40px;
  }

  .service-tags {
    width: 1180px;
    position: absolute;
    bottom: 30px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    z-index: 8;
  }

  .tag-item {
    flex: 1;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px 20px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    img {
      width: 32px;
      margin-right: 12px;
    }
  }

  .itsm-overview {
    padding: 70px 0px;
    background-color: #fff;
  }

  .itsm-overview h2 {
    font-size: 24px;
    color: #1f2d3d;
    text-align: center;
    margin: 0;
    margin-bottom: 40px;
  }

  .overview-cards {
    max-width: 1180px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    img {
      width: 48px;
      margin-right: 14px;
    }
  }

  .overview-card {
    background-color: #F1F6FC;
    padding: 14px 20px;
    border-radius: 8px;
    text-align: left;
    display: flex;
    align-items: center;
    color: #475669;
    font-size: 16px;
  }

  .features-intro {
    background-color: #fff;
    padding-bottom: 50px;
  }

  .features-intro h2 {
    font-size: 24px;
    color: #1f2d3d;
    text-align: center;
    margin: 0;
    margin-bottom: 40px;
  }

  .features-cards {
    max-width: 1180px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }

  .feature-card {
    height: 360px;
    background-color: #fff;
    padding: 24px;
    border-radius: 8px;
    text-align: left;
    color: #475669;
    background: url("../../assets/operations/itsm11.png") no-repeat center / cover;

    &:hover {
      background: url("../../assets/operations/itsm12.png") no-repeat center / cover;
    }
  }

  .feature-card h3 {
    font-size: 18px;
    color: #1f2d3d;
    margin-bottom: 20px;
  }

  .feature-card p {
    font-size: 14px;
    line-height: 1.6;
  }
}
</style>
